export const SET_GLOBAL_SEARCH = 'SetGlobalSearch';
export const SET_TOTAL_COUNT_ALL_AREAS = 'SetTotalCountAllAreas';
export const SET_SEARCH_PARAMETERS = 'SetSearchParameters';
export const SET_AREA_SEARCH = 'SetAreaSearch';
export const SET_AREA_SEARCH_PARAMETERS = 'SetAreaSearchParameters';
export const CLEAR_ALL_AREA_SEARCH_PARAMETERS = 'ClearAllAreaSearchParameters';
export const CLEAR_ALL_AREA_SEARCHES = 'ClearAllAreaSearches';
export const SET_AREA_SEARCH_PAGE = 'SetAreaSearchPage';
export const SET_CURRENT_MODAL = 'SetCurrentModal';
export const SET_ACTIVITY_POPOVER = 'SetActivityPopOver';
export const CLEAR_AREA_SEARCH_PAGE = 'ClearAreaSearchPage';
